<div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-h-0 min-w-0">
    @if (signin) {

        <div
        class="w-full px-4 py-8 sm:bg-card sm:w-auto sm:rounded-2xl sm:p-12 sm:shadow"
    >
        <div class="mx-auto w-full max-w-80 sm:mx-0 sm:w-80">
            <!-- Logo -->
            <div class="w-12">
                <img src="assets/irbe7/LogoIrbe7-01.webp"  [alt]="'logo'" />
            </div>

            <!-- Title -->
            <div
                class="mt-8 text-4xl font-extrabold leading-tight tracking-tight"
            >
               Se Connecter
            </div>
            <div class="mt-0.5 flex items-baseline font-medium">
                <div>Vous n'avez pas de compte ?</div>
                <a
                    class="ml-1 text-primary-500 hover:underline"
                     (click)="enableSignUp()">S'inscrire
                </a>
            </div>

            <!-- Alert -->
            @if (showAlert) {
                <fuse-alert
                    class="mt-8"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'"
                >
                    {{ alert.message }}
                </fuse-alert>
            }

            <!-- Sign in form -->
            <form class="mt-8" [formGroup]="signInForm" #signInNgForm="ngForm">
                <!-- Email field -->
                <mat-form-field class="w-full">
                    <mat-label>Nom d'utilisateur</mat-label>
                    <input id="user" matInput [formControlName]="'user'" />
                    @if (signInForm.get('user').hasError('required')) {
                        <mat-error> Ce champ est obligatoire </mat-error>
                    }
                </mat-form-field>

                <!-- Password field -->
                <mat-form-field class="w-full">
                    <mat-label>Mot de passe</mat-label>
                    <input
                        id="password"
                        matInput
                        type="password"
                        [formControlName]="'password'"
                        #passwordField
                    />
                    <button
                        mat-icon-button
                        type="button"
                        (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        "
                        matSuffix
                    >
                        @if (passwordField.type === 'password') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                        }
                        @if (passwordField.type === 'text') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye-slash'"
                            ></mat-icon>
                        }
                    </button>
                    <mat-error>Ce champ est obligatoire </mat-error>
                </mat-form-field>


                <!-- Submit button -->
                <button
                    class="fuse-mat-button-large mt-6 w-full"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="signInForm.disabled"
                    (click)="login()"
                >
                    @if (!signInForm.disabled) {
                        <span>  Se Connecter </span>
                    }
                    @if (signInForm.disabled) {
                        <mat-progress-spinner
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>
                   
            </form>
        </div>
    
    </div>
}
@if (signup) {
    <div
    class="w-full px-4 py-8 sm:bg-card sm:w-auto sm:rounded-2xl sm:p-12 sm:shadow"
>
    <div class="mx-auto w-full max-w-80 sm:mx-0 sm:w-80">
        <!-- Logo -->
        <div class="w-12">
            <img src="assets/irbe7/LogoIrbe7-01.webp" [alt]="'logo'" />
        </div>

        <!-- Title -->
        <div
            class="mt-8 text-4xl font-extrabold leading-tight tracking-tight"
        >
           S'inscrire
        </div>
        <div class="mt-0.5 flex items-baseline font-medium">
            <div>Vous avez déjà un compte ?</div>
            <a
                class="ml-1 text-primary-500 hover:underline"
             (click)="enableSignIn()">Se Connecter
            </a>
        </div>

        <!-- Alert -->
        @if (showAlert) {
            <fuse-alert
                class="mt-8"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'"
            >
                {{ alert.message }}
            </fuse-alert>
        }
<!-- Alert -->
      @if (showAlert1) {
        <fuse-alert
            class="mt-8 -mb-4"
            [appearance]="'outline'"
            [showIcon]="false"
            [type]="alert1.type"
            [@shake]="alert1.type === 'error'">
            {{alert1.message}}
        </fuse-alert>
}
      @if (showAlert2) {
        <fuse-alert
            class="mt-8 -mb-4"
            [appearance]="'outline'"
            [showIcon]="false"
            [type]="alert2.type"
            [@shake]="alert2.type === 'success'">
            {{alert2.message}}
        </fuse-alert>
}
        <!-- Sign Up form -->
        <form class="mt-8" [formGroup]="signUpForm"    #signUpNgForm="ngForm">
            <!-- Name field -->
            <mat-form-field class="w-full">
                <mat-label>Nom d'utilisateur</mat-label>
                <input id="username" matInput [formControlName]="'username'" />
                @if (signUpForm.get('username').hasError('required')) {
                    <mat-error> Ce champ est obligatoire </mat-error>
                }
            </mat-form-field>

            <!-- Email field -->
            <mat-form-field class="w-full">
                <mat-label>Adresse Email</mat-label>
                <input id="email" matInput [formControlName]="'email'" />
                @if (signUpForm.get('email').hasError('required')) {
                    <mat-error> Ce champ est obligatoire </mat-error>
                }
                @if (signUpForm.get('email').hasError('email')) {
                    <mat-error>
                        Entrer une adresse email valide
                    </mat-error>
                }
            </mat-form-field>

            <!-- Password field -->
            <mat-form-field class="w-full">
                <mat-label>Mot de passe</mat-label>
                <input
                    id="password1"
                    matInput
                    type="password"
                    [formControlName]="'password1'"
                    #passwordField
                />
                <button
                    mat-icon-button
                    type="button"
                    (click)="
                        passwordField.type === 'password'
                            ? (passwordField.type = 'text')
                            : (passwordField.type = 'password')
                    "
                    matSuffix
                >
                    @if (passwordField.type === 'password') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye'"
                        ></mat-icon>
                    }
                    @if (passwordField.type === 'text') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye-slash'"
                        ></mat-icon>
                    }
                </button>
                <mat-error>  Ce champ est obligatoire </mat-error>
            </mat-form-field>


            <!-- ToS and PP -->
            <div class="mt-1.5 inline-flex w-full items-end">
                <mat-checkbox
                    class="-ml-2"
                    [color]="'primary'"
                >
                    <span>J'accepte les conditions d'utilisation et la politique de confidentialité</span>
                </mat-checkbox>
            </div>

            <!-- Submit button -->
            <button
                class="fuse-mat-button-large mt-6 w-full"
                mat-flat-button
                [color]="'primary'"
                [disabled]="signUpForm.disabled"
              (click)="signUp()"
            >
                @if (!signUpForm.disabled) {
                    <span>  Créer Votre Compte </span>
                }
                @if (signUpForm.disabled) {
                    <mat-progress-spinner
                        [diameter]="24"
                        [mode]="'indeterminate'"
                    ></mat-progress-spinner>
                }
            </button>
        </form>
    </div>
</div>

  
}
    <div class="relative hidden md:flex flex-auto items-center justify-center w-1/2 h-full p-20 lg:px-28 overflow-hidden">
        
        <!-- Content -->
        <div class="z-10 relative w-full max-w-1xl mb-6">
            <div class="text-5xl font-bold leading-none ml-12">
               <p style="color: #4524cb;" class="mb-2">Rejoignez </p> <p style="color: #4524cb;" class="mb-2">notre communauté </p>
               <p style="color: #fdbe01;" class="mb-2">VIP <span style="color: #4524cb;"> gratuitement</span></p> 
            </div>
            
            <div class="flex items-center mt-8">
                <div class="flex flex-0 items-center -space-x-1.5 max-w-120">
                    <img
                        src="assets/irbe7/login.webp" [alt]="'logo'">
                    
                </div>
            </div>
        </div>
    </div>
    <mat-icon svgIcon="heroicons_outline:x-mark" style="cursor: pointer;" (click)="fermer()"></mat-icon>
</div>